/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable import/no-unresolved */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { each, isEmpty } from 'lodash';
import { SecurityModel } from 'api';
import { BACKSOLVE_SECURITY_ALIAS } from 'common/constants/allocations';
import { CustomSelect, withTooltip } from 'components';
import { OptionType } from 'components/CustomSelect/types';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import LedgerContext from 'context/LedgerContext';
import { CellValue, ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { filterSecurities, toString } from 'utilities';
import { CaptableSecuritiesProps } from './CaptableSecurities.props';

const defaultCell = {
  value: null,
  key: null,
} as unknown as ICell;

const CaptableSecurities = (props: CaptableSecuritiesProps) => {
  const { cell = defaultCell, securityList = [], menuPosition = 'bottom', onCommit, onRevert } = props;
  const [securities, setSecurities] = useState<SecurityModel[]>([]);
  const { cells: allocationCells } = useContext(FeaturedSpreadsheetContext);

  const { onCellsChange, cells: ledgerCells } = useContext(LedgerContext);

  useEffect(() => {
    if (allocationCells) {
      const selectedSecurities: CellValue[] = [];

      each(ledgerCells, ledgerCell => {
        if (ledgerCell.alias === BACKSOLVE_SECURITY_ALIAS && toString(cell.value) !== toString(ledgerCell.value)) {
          selectedSecurities.push(ledgerCell.value);
        }
      });

      const filteredSecurities = Array.isArray(securityList)
        ? securityList.filter(({ id }) => !selectedSecurities.includes(id))
        : [];

      setSecurities(filteredSecurities);
    }
  }, [securityList, ledgerCells, cell.value]);

  const handleChange = (value: string | null) => {
    const newValue = value;
    onCellsChange([
      {
        cell,
        value: newValue,
      },
    ]);
  };

  const optionIsListed = useMemo(() => {
    if (securities && Array.isArray(securities)) {
      const isListed = securities.find(item => toString(item.id) === toString(cell.value));
      return !!isListed;
    }

    return false;
  }, [securities]);

  const getOptions = useMemo(() => {
    const tmpOptions: OptionType[] = [];
    if (securities) {
      const tmpSecurities = filterSecurities(securities);

      tmpSecurities.forEach(security => {
        tmpOptions.push({
          value: security.id as number,
          label: security.name,
        });
      });
    }

    return tmpOptions;
  }, [securities]);

  if (isEmpty(securities)) {
    return <span>No securities available</span>;
  }

  return (
    <CustomSelect
      id={`captable-securities-${cell.key}`}
      value={(optionIsListed && (cell.value as string)) || ''}
      options={getOptions}
      onChange={handleChange}
      onCommit={onCommit}
      onRevert={onRevert}
      onEmptyValue="SELECT SECURITY"
      disabled={cell.readOnly}
      menuPosition={menuPosition}
      openMenuOnFocus
      autoFocus
    />
  );
};

export default withTooltip(CaptableSecurities);
